import { ListingColDefs } from './listing-col-defs';
import { InspectionText } from '@/property-inspections/constants';
import dayjs from 'dayjs';

/**
 * Use this class to statically generate ag-grid column defs for the inspection grid
 */
export class InspectionsColDefs extends ListingColDefs {
  licenseColumnFieldName = 'strLicense';

  licenseDisplayedColumnFieldName = 'strLicenseDisplayed';

  groupNodesWithCheckboxes = true;

  inspectionNumberColumn = this.textColumn({
    pinned: 'left',
    headerName: 'Inpsection Number',
    field: 'id',
  });

  inspectionAddressColumn = this.textColumn({
    headerName: 'Address',
    field: 'propertyAddress',
  });

  inspectionResultColumn = this.textColumn({
    headerName: 'Inspection Result',
    field: 'inspectionResult',
    valueFormatter: ({ value }) => InspectionText[value],
  });

  inspectionSubmissionTimeColumn = this.textColumn({
    headerName: 'Submission Time',
    field: 'submissionTime',
    valueFormatter: ({ value }) => {
      const date = dayjs.utc(value).local();
      return date.format('MM-DD-YYYY');
    },
  });

  inspectionInspectionTimeColumn = this.textColumn({
    headerName: 'Inspection Time',
    field: 'inspectionTime',
    valueFormatter: ({ value }) => {
      const date = dayjs.utc(value).local();
      return date.format('MM-DD-YYYY');
    },
  });

  inspectionInspectorColumn = this.textColumn({
    headerName: 'Inspector',
    field: 'inspector',
  });

  /**
   * Groups of columns for Inspections
   *
   * @override
   */
  columnGroups() {
    return [
      {
        headerName: 'Property details',
        children: [this.apnColumn, this.inspectionAddressColumn],
      },
      {
        headerName: 'Inspection Information',
        children: [
          this.inspectionNumberColumn,
          this.inspectionResultColumn,
          this.inspectionSubmissionTimeColumn,
          this.inspectionInspectionTimeColumn,
          this.inspectionInspectorColumn,
        ],
      },
    ];
  }
}
